import { useState } from 'react'
import { apiEtapa2 } from '../api'
import Aviso from '../../components/Aviso'
import { moeda, pct } from '../../components/format'
import { Campo, Cards, Gravado, Recibo, dataBR } from '../componentes'

const TIPOS = [
  ['SEM_JUSTA_CAUSA', 'Dispensa sem justa causa', ['INDENIZADO', 'TRABALHADO']],
  ['PEDIDO_DEMISSAO', 'Pedido de demissão', ['TRABALHADO', 'NAO_CUMPRIDO', 'DISPENSADO']],
  ['ACORDO_484A', 'Acordo (art. 484-A)', ['INDENIZADO', 'TRABALHADO']],
]
const SITUACOES = {
  INDENIZADO: 'Indenizado',
  TRABALHADO: 'Trabalhado',
  NAO_CUMPRIDO: 'Não cumprido (desconto)',
  DISPENSADO: 'Dispensado pela empresa',
}

export default function Rescisao({ empresaId }) {
  const [f, setF] = useState({
    funcionario_id: 'F1', nome: '', dependentes_irrf: 0, tipo: 'SEM_JUSTA_CAUSA', situacao_aviso: 'INDENIZADO',
    data_admissao: '', data_desligamento: '', salario_base: '', media_variaveis: '0',
    periodos_ferias_vencidas: 0, periodos_ferias_em_dobro: 0, faltas_periodo_aquisitivo_atual: 0,
    adiantamento_decimo_terceiro: '0', saldo_fgts: '0', data_pagamento: '',
  })
  const [res, setRes] = useState(null)
  const [erro, setErro] = useState('')
  const [carregando, setCarregando] = useState(false)
  const set = (k) => (e) => {
    const valor = e.target.value
    setF((atual) => {
      const novo = { ...atual, [k]: valor }
      if (k === 'tipo') novo.situacao_aviso = TIPOS.find((t) => t[0] === valor)[2][0]
      return novo
    })
  }
  const situacoes = TIPOS.find((t) => t[0] === f.tipo)[2]

  async function calcular(gravar) {
    setErro('')
    setCarregando(true)
    try {
      const entrada = {
        ...f,
        empresa_id: empresaId,
        dependentes_irrf: Number(f.dependentes_irrf) || 0,
        periodos_ferias_vencidas: Number(f.periodos_ferias_vencidas) || 0,
        periodos_ferias_em_dobro: Number(f.periodos_ferias_em_dobro) || 0,
        faltas_periodo_aquisitivo_atual: Number(f.faltas_periodo_aquisitivo_atual) || 0,
        data_pagamento: f.data_pagamento || null,
      }
      setRes(await apiEtapa2.calcularRescisao(entrada, gravar))
    } catch (e) {
      setErro(e.message)
      setRes(null)
    } finally {
      setCarregando(false)
    }
  }

  const r = res?.resultado
  return (
    <section>
      <h2>Rescisão contratual</h2>
      <div className="grade">
        <Campo rotulo="Tipo de rescisão">
          <select value={f.tipo} onChange={set('tipo')}>
            {TIPOS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </Campo>
        <Campo rotulo="Aviso prévio">
          <select value={f.situacao_aviso} onChange={set('situacao_aviso')}>
            {situacoes.map((s) => <option key={s} value={s}>{SITUACOES[s]}</option>)}
          </select>
        </Campo>
        <Campo rotulo="Matrícula"><input value={f.funcionario_id} onChange={set('funcionario_id')} /></Campo>
        <Campo rotulo="Nome"><input value={f.nome} onChange={set('nome')} /></Campo>
        <Campo rotulo="Admissão"><input type="date" value={f.data_admissao} onChange={set('data_admissao')} /></Campo>
        <Campo rotulo="Último dia trabalhado"><input type="date" value={f.data_desligamento} onChange={set('data_desligamento')} /></Campo>
        <Campo rotulo="Salário base"><input type="number" step="0.01" value={f.salario_base} onChange={set('salario_base')} /></Campo>
        <Campo rotulo="Média mensal de variáveis"><input type="number" step="0.01" value={f.media_variaveis} onChange={set('media_variaveis')} /></Campo>
        <Campo rotulo="Dependentes IRRF"><input type="number" min="0" value={f.dependentes_irrf} onChange={set('dependentes_irrf')} /></Campo>
        <Campo rotulo="Períodos de férias vencidas"><input type="number" min="0" max="2" value={f.periodos_ferias_vencidas} onChange={set('periodos_ferias_vencidas')} /></Campo>
        <Campo rotulo="Desses, em dobro"><input type="number" min="0" max="2" value={f.periodos_ferias_em_dobro} onChange={set('periodos_ferias_em_dobro')} /></Campo>
        <Campo rotulo="Faltas no período aquisitivo atual"><input type="number" min="0" value={f.faltas_periodo_aquisitivo_atual} onChange={set('faltas_periodo_aquisitivo_atual')} /></Campo>
        <Campo rotulo="Adiantamento de 13º já pago"><input type="number" step="0.01" value={f.adiantamento_decimo_terceiro} onChange={set('adiantamento_decimo_terceiro')} /></Campo>
        <Campo rotulo="Saldo FGTS (fins rescisórios)"><input type="number" step="0.01" value={f.saldo_fgts} onChange={set('saldo_fgts')} /></Campo>
        <Campo rotulo="Data de pagamento"><input type="date" value={f.data_pagamento} onChange={set('data_pagamento')} /></Campo>
      </div>
      <div className="acoes">
        <button disabled={carregando || !empresaId} onClick={() => calcular(false)}>Calcular</button>
        <button className="secundario" disabled={carregando || !empresaId} onClick={() => calcular(true)}>Calcular e gravar</button>
      </div>
      <Aviso>{erro}</Aviso>
      {r && (
        <>
          <Gravado registroId={res.registro_id} />
          <Cards
            itens={[
              ['Líquido da rescisão', moeda(r.liquido), `Pagar até ${dataBR(r.data_limite_pagamento)}`],
              ['Aviso prévio', `${Number(r.dias_aviso_previo)} dias`, `${r.anos_completos} anos completos · ${Number(r.dias_aviso_indenizado)} indenizados · projeção ${dataBR(r.data_projetada_aviso)}`],
              ['Multa FGTS', moeda(r.fgts.multa), `${pct(r.fgts.percentual_multa, 0)} de ${moeda(r.fgts.base_multa)}`],
              ['FGTS movimentável', r.fgts.saque_liberado ? moeda(r.fgts.valor_movimentavel_estimado) : 'Sem saque', r.fgts.saque_liberado ? `${pct(r.fgts.percentual_movimentacao, 0)} (estimativa)` : ''],
            ]}
          />
          <Recibo titulo="Termo de rescisão" resultado={r} />
        </>
      )}
    </section>
  )
}
